/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Dialog_Edit_TitleInputs */



/**
* | output |
* | --- |
* | "Edit Alarm" |
*
* @param {Alarms_Dialog_Edit_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const alarms_dialog_edit_title = /** @type {((inputs?: Alarms_Dialog_Edit_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Dialog_Edit_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Edit Alarm")
	return /** @type {LocalizedString} */ ("Modifier une alarme")
});